/**
 * NotFoundPage — the styled 404 experience.
 *
 * Rendered by the catch-all ("*") route INSIDE MarketingLayout, so the visitor
 * keeps the shared site chrome (main navigation + footer), stays on the URL
 * they typed (no silent redirect to "/"), and always has an obvious way onward.
 */
import { Link } from "react-router";
import { buttonVariants } from "@diality/ui";

export function NotFoundPage() {
  return (
    <section className="text-brand-dark-gray mx-auto flex flex-col items-center gap-4 px-6 pb-24 text-center sm:pb-32 pt-43.5 max-[1160px]:pt-35">
      <p className="text-sm font-semibold font-sans uppercase pb-2 tracking-[1.12px]">
        404
      </p>
      <h1 className="text-5xl font-display font-light leading-[104%] tracking-[-1.92px] sm:text-8xl">
        Page Not Found
      </h1>
      <p className="text-xl font-sans font-light leading-[155%] max-w-135.5 pb-2">
        The page you&rsquo;re looking for doesn&rsquo;t exist or may have been
        moved. Nothing is wrong on your end — use the navigation above or head
        back to the homepage to keep exploring.
      </p>
      <Link to="/" className={buttonVariants({ size: "sm" })}>
        Back to Homepage
      </Link>
    </section>
  );
}
